import { TextCell } from '@ayocore/platform/client/components/EditableGrid';
import type { SupplierQuoteColumnKey, SupplierQuoteLike, SupplierQuotePatch } from './types';

export const quoteProductNameColumn = TextCell<
  SupplierQuoteLike,
  SupplierQuotePatch,
  SupplierQuoteColumnKey
>({
  key: 'product_name',
  title: 'Наименование товара',
  width: 180,
});
